// Library imports
import styled from 'styled-components';
import { MDBContainer, MDBModalDialog } from 'mdb-react-ui-kit';
// Constant imports
import { POWER_BREAK_POINT } from './PowerRank/constants';
import { SMALL_SCREEN_WIDTH } from '../../../utils/constants';

export const InnerContent = styled(MDBContainer)`
    overflow-y: scroll;
    padding-top: 0.5rem;
    padding-bottom: 1rem;
    touch-action: pan-y pinch-zoom;
    background: #0f1117 !important;
    /* hide scrollbars cross-browser */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar { display: none; }
`;

export const CardTitle = styled.span`
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: 700;
    font-size: 1rem;
    white-space: nowrap;
    padding: 0.75rem 1rem;
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.45rem;
    color: #e2e8f0;
    @media (max-width: ${POWER_BREAK_POINT}) {
        ${p => p.responsive && 'padding: 0.75rem 0px;'}
    }
    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        font-size: 0.9rem;
    }
`;

// Game-detail modals (schedule game, pitcher history). Use with `scrollable` so only the body scrolls and the
// header/footer close buttons stay on screen; on phones the dialog is inset so it doesn't fill the screen.
export const GameDetailsModalDialog = styled(MDBModalDialog)`
    && {
        @media (max-width: ${SMALL_SCREEN_WIDTH}) {
            width: auto;
            max-width: none;
            height: 80vh;
            min-height: 0;
            margin: 10vh 1rem;
        }
    }
`;

/** Small logo with white plate backdrop, for inline team name rows */
export const TeamLogoSmall = styled.img`
    width: 20px;
    height: 20px;
    object-fit: contain;
    background: rgba(255,255,255,0.88);
    border-radius: 50%;
    padding: 2px;
    flex-shrink: 0;
    box-shadow: 0 0 0 1px rgba(255,255,255,0.18), 0 1px 4px rgba(0,0,0,0.4);
`;

export const TeamRank = styled.span`
    position: absolute;
    font-size: 18px;
    top: -25px;
    ${({ right }) => (right === 'true' ? 'right: -20px;' : 'left: 10px;')}
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
`;

export const HighLightedField = styled.span`
    ${props => props.width && `width: ${props.width};`}
    background: ${({ variant }) =>
        variant === 'success' ? 'rgba(34,197,94,0.12)' :
        variant === 'danger'  ? 'rgba(239,68,68,0.12)' :
        variant === 'primary' ? 'rgba(59,130,246,0.12)' :
        'rgba(255,255,255,0.05)'};
    border: 1px solid ${({ variant }) =>
        variant === 'success' ? 'rgba(34,197,94,0.4)' :
        variant === 'danger'  ? 'rgba(239,68,68,0.4)' :
        variant === 'primary' ? 'rgba(59,130,246,0.6)' :
        'rgba(255,255,255,0.1)'};
    color: ${({ variant }) =>
        variant === 'success' ? '#4ade80' :
        variant === 'danger'  ? '#f87171' :
        variant === 'primary' ? '#93c5fd' :
        '#cbd5e1'};
    text-align: center;
    padding: 6px 10px;
    font-weight: 700;
    border-radius: 8px;
    white-space: nowrap;
    display: block;
    @media (max-width: ${POWER_BREAK_POINT}) {
        span { font-size: 14px; }
    }
`;

export const TwoColWrap = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.55rem;
    padding: 0.4rem 0.5rem;
`;

export const NoDataMessage = styled.div`
    margin: 0.55rem;
    padding: 1rem 1.1rem;
    border: 1px dashed rgba(148,163,184,0.35);
    border-radius: 10px;
    background: rgba(255,255,255,0.02);
    color: #94a3b8;
    text-align: center;

    i {
        font-size: 1rem;
        margin-bottom: 0.45rem;
        color: #94a3b8;
    }

    p {
        margin: 0;
        font-size: 0.78rem;
        line-height: 1.4;
    }
`;

/** Team header row: logo + white name, used at the top of each team column */
